function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { BtnClose, ButtonsWrapper, ContentBody, ContentButton, ContentButtonIcon, ContentHead, ContentWrapper, ExtendableOverlayContentWrapper, ModalOverlayContentWrapper } from './styled';
const stopPropagation = event => {
  event.stopPropagation();
};
export const ExtendableOverlayContent = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ExtendableOverlayContentWrapper, _extends({}, props, {
    onClick: stopPropagation
  }), children);
};
export const ModalOverlayContent = _ref2 => {
  let {
    children,
    container,
    className,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(ExtendableOverlayContentWrapper, {
    noScroll: true,
    container: container,
    className: className
  }, /*#__PURE__*/React.createElement(ModalOverlayContentWrapper, _extends({}, props, {
    onClick: stopPropagation
  }), children));
};
const CustomConfirmOverlay = _ref3 => {
  let {
    title,
    body,
    handleConfirm,
    handleReject,
    confirmText,
    rejectText,
    confirmIcon,
    rejectIcon,
    actionType,
    className,
    container,
    confirmActionOnly,
    cancelActionOnly,
    confirmDisabled,
    confirmClassName
  } = _ref3;
  return /*#__PURE__*/React.createElement(ModalOverlayContent, {
    container: container,
    className: className
  }, /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(ContentHead, null, title, /*#__PURE__*/React.createElement(BtnClose, {
    onClick: handleReject
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faXmark
  }))), /*#__PURE__*/React.createElement(ContentBody, null, body), /*#__PURE__*/React.createElement(ButtonsWrapper, null, confirmActionOnly ? /*#__PURE__*/React.createElement(ContentButton, {
    onClick: handleConfirm,
    color: "tertiary",
    className: classnames(actionType?.length > 1 ? `delete` : `download`, confirmClassName),
    disabled: confirmDisabled
  }, confirmText || 'Supprimer', confirmIcon && /*#__PURE__*/React.createElement(ContentButtonIcon, {
    icon: confirmIcon
  })) : cancelActionOnly ? /*#__PURE__*/React.createElement(ContentButton, {
    onClick: handleReject,
    color: "medium"
  }, rejectText || 'Annuler', rejectIcon && /*#__PURE__*/React.createElement(ContentButtonIcon, {
    icon: rejectIcon
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContentButton, {
    onClick: handleConfirm,
    color: "tertiary",
    className: classnames(actionType?.length > 1 ? `delete` : `download`, confirmClassName),
    disabled: confirmDisabled
  }, confirmText || 'Supprimer', confirmIcon && /*#__PURE__*/React.createElement(ContentButtonIcon, {
    icon: confirmIcon
  })), /*#__PURE__*/React.createElement(ContentButton, {
    onClick: handleReject,
    color: "medium"
  }, rejectText || 'Annuler', rejectIcon && /*#__PURE__*/React.createElement(ContentButtonIcon, {
    icon: rejectIcon
  }))))));
};
CustomConfirmOverlay.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  handleReject: PropTypes.func,
  confirmText: PropTypes.node,
  rejectText: PropTypes.node,
  container: PropTypes.string,
  confirmIcon: PropTypes.any,
  rejectIcon: PropTypes.any,
  actionType: PropTypes.string,
  className: PropTypes.string,
  confirmActionOnly: PropTypes.bool,
  cancelActionOnly: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
  confirmClassName: PropTypes.string
};
export default CustomConfirmOverlay;